import {
    CUSTOMER_LOADING, CUSTOMER_SUCCESS,
    CUSTOMER_ERROR, RESET_CUSTOMER
} from "../actions/actionCustomer";

const initialState = {
    customer: [],
    loading: false,
    customerError: ''
};

function reducerCustomer(state = initialState, action) {

    switch (action.type) {
        case CUSTOMER_LOADING: {
            return {
                ...state,
                loading: true
            };
        }

        case CUSTOMER_SUCCESS: {

            return {
                ...state,
                customer: action.payload,
                customerError: ''
            };
        }

        case CUSTOMER_ERROR: {

            return {
                ...state,
                customer: [],
                customerError: action.error
            };
        }

        case RESET_CUSTOMER: {

            return {
                ...state,
                loading: false,
                customer: [],
                customerError: ''
            }
        }

        default: {
            return state;
        }
    }
}

export default reducerCustomer;